import React from 'react';
import { Button, Row, Col } from 'reactstrap';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Link from './Link';
import {
  analyticsTrack,
  EVENT_OBJECT,
  EVENT_VERB,
  eventBuilder,
} from '../utils/tracking';

// This component shows the expert preview

const ExpertPreview = ({ expert }) => {
  const src = getImage(expert.image);

  const handleClick = () => {
    analyticsTrack({
      event: eventBuilder(EVENT_OBJECT.button, EVENT_VERB.interacted),
      params: {
        label: 'Profil ansehen',
        to: `/experten/${expert.slug}/`,
        element_type: 'ExpertPreview',
      },
    });
  };

  console.log('expert', expert);
  return (
    <Row xs="1" md="2" className="mb-6">
      <Col>
        {expert.image?.gatsbyImageData && (
          <GatsbyImage
            /*
             * Alternative: This is the solution works if you want to control height of the image
             * imgStyle={{
             *   objectPosition: 'top',
             * }}
             * style={{
             *   maxHeight: '300px',
             * }}
             */
            image={{
              ...src,
              layout: 'fullWidth',
              objectFit: 'cover',
              objectPosition: 'top',
            }}
            alt={expert.image.title}
            className="w-100 h-100"
          />
        )}
      </Col>
      <Col>
        <h3 className="text-break">
          <Link
            to={`/experten/${expert.slug}/`}
            eventLabel={expert.title}
            eventParams={{ element_type: 'ExpertPreview' }}
          >
            {expert.title}
          </Link>
        </h3>
        <h4>{expert.company}</h4>
        {expert.freeText && (
          <div
            className="body pb-5"
            dangerouslySetInnerHTML={{
              __html: expert.freeText.childMarkdownRemark.html,
            }}
          />
        )}
        <Button
          className="mt-3"
          tag={Link}
          to={`/experten/${expert.slug}/`}
          color="primary"
          textColor="white"
          onClick={handleClick}
        >
          Profil ansehen
        </Button>
      </Col>
    </Row>
  );
};

export default ExpertPreview;
